import dayjs from "dayjs";
import s from "./style.module.scss";
import {
  currentServiceAction,
  currentServiceAtom,
  currentServiceIsLoadingAtom,
} from "../../core/reatom/state/currentService/currentService";
import { useAction, useAtom } from "@reatom/npm-react";
import { Skeleton } from "@vkontakte/vkui";
import clsx from "clsx";
import { freelanceAtom } from "@/core/reatom/state/search";
import { useEffect } from "react";

interface UserLineProps {
  onClick?: () => void;
  name?: string;
  isLoading?: boolean;
  photo_url?: string;
  reg_date?: number;
}

export const UserLine = (props: UserLineProps) => {
  const { onClick, isLoading, name, photo_url } = props;
  const [currentService] = useAtom(currentServiceAtom);
  const [isLoadingAtom] = useAtom(currentServiceIsLoadingAtom);
  const [freelancerProducts] = useAtom(freelanceAtom);
  const handleFetchService = useAction(currentServiceAction);
  useEffect(() => {
    if (!freelancerProducts?.items[0]?.id) return;
    if (freelancerProducts?.items[0]?.id === currentService?.id) return;
    handleFetchService(`${freelancerProducts?.items[0]?.id}`);
  }, [freelancerProducts]);
  return (
    <div className={s.userLine} onClick={onClick}>
      {isLoadingAtom && isLoading ? (
        <div className={s.userInfo}>
          <Skeleton className={clsx(s.avatar)} width={48} />
          <div>
            <Skeleton width={120} height={48} />
          </div>
        </div>
      ) : (
        <>
          <div className={s.userInfo}>
            <img
              src={
                photo_url ??
                currentService?.user.photo_url ??
                freelancerProducts?.items[0]?.user.photo_url
              }
              alt=""
              className={s.avatar}
            />
            <div>
              <p className={s.name}>
                {name ||
                  currentService?.user.full_name ||
                  currentService?.user.username}
              </p>
              <p className={s.workingTime}>
                {name ? (
                  "Заказчик"
                ) : (
                  <>
                    {`Работает на FL с `}
                    {dayjs(currentService?.user.reg_date).get("year")}г
                  </>
                )}
              </p>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
